import { HiOutlineUsers } from 'react-icons/hi'

import Title from '../title/Title'
import BannerPage from '../bannerpage/BannerPage'
import Empty from '../empty/Empty'
import FriendSlider from './FriendSlider'
import './friend.css'
import UserAppContext from '../../hook/UserAppContext'

const Friends = ({isCurrent}) => {

      if(isCurrent !== 'friend') return 

      const {user, data} = UserAppContext()
      const {friends, banners} = user.user 
      const banner = banners.data ? data.banner.image : banners[0].image 
      const title = banners.data ? data.banner.title : banners[0].title 

      if(friends.data){

            return (
                  <div className="page_content">
                        <Empty title={`Not found`} />
                  </div>
            )
      }

      return (
            <div className="page_content">
                  <Title title={`My Friends`} icon={<HiOutlineUsers />} />
                  <div className="page_inner">
                        <BannerPage banner={banner} title={title} isCurrent={isCurrent}/>
                        <div className="pager_inner__box friend">
                              <div className="friend_content">
                                    <FriendSlider friends={friends} />
                              </div>
                        </div>
                  </div>
            </div>
      )
}

export default Friends
